<template>
  <!-- 待办事项 -->
  <div class="page_box">
    <div class="page_table_box" style="height:calc(100% -  10px)">
      <div class="school_table_box">
        <el-table :data="tableData" height="100%" 
          class="table_box"
          :header-cell-style="{ background: '#E2EEFF', color: '#474859' }">
          <el-table-column label="序号" width="70" fixed align="center">
            <template slot-scope="scope">
              {{
                requestData.pageSize * (requestData.pageNum - 1) +
                  scope.$index +
                  1
              }}
            </template>
          </el-table-column>
          <el-table-column
            prop="noticeDescription"
            label="待办内容"
            show-overflow-tooltip
            align="center"
          >
          </el-table-column>
          <el-table-column prop="date" label="发布时间" width="180px" align="center">
            <template slot-scope="scope">
              {{ $Common.dateFormatDateTwo(scope.row.reportingTime) }}
            </template>
          </el-table-column>
          <el-table-column label="状态" width="120px" align="center">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.isNew == 0" size="small" type="success"
                >最新</el-tag
              >
              <el-tag v-else type="info" size="small">已读</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="180" align="center">
            <template slot-scope="scope">
              <el-link
                class="link_box"
                type="primary"
                :underline="false"
                @click="checkInfo(scope.row.id)"
                >查看</el-link
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination_box">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="requestData.pageNum"
          :page-size="requestData.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  components: {},
  props: {},
  data() {
    return {
      tableData: [],
      total: 0,
      requestData: {
        pageNum: 1,
        pageSize: 20,
        recipientId: this.$store.getters.getUserInfo.userId,
        schoolId: this.$store.state.schoolId
      }
    };
  },
  watch: {},
  computed: {},
  methods: {
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.requestData.pageNum = val;
      this.getList();
    },
    // 获取数据列表
    async getList() {
      let res = await this.$Http.getHiddenDangerToList(this.requestData);
      if (res.code == 200) {
        this.total = res.data.total || 0;
        this.tableData = res.data.list || [];
      } else if (res.code == 101) {
        this.total = 0;
        this.tableData = [];
      } else {
        this.total = 0;
        this.tableData = [];
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    async checkInfo(id) {
      let res = await this.$Http.updDangerTo({ id: id }, true);
      if (res.code == 200) {
        this.$Common.pageJump("/hidden_danger_data", "", 0);
        this.$store.commit("setSelect", false);
        this.$store.commit("updatePathIndex", '1-0-0');
      } else {
      }
    }
  },
  created() {},
  mounted() {
    this.getList();
  }
};
</script>
